export function replace(string) {
    return string.replace(/;/g, ' •');
}